import React, { useState, useEffect } from 'react';
import { View, TextInput, StyleSheet, Text, FlatList, Image, ScrollView, Dimensions, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const SearchBar = ({ navigation, usuario_id }) => {
    const [searchText, setSearchText] = useState('');
    const [medicamentos, setMedicamentos] = useState([]);

    useEffect(() => {
        async function buscarMedicamentos() {
            const url = 'https://api-doseexata.josuejuca.com/api/v1/medicamentos/?skip=0&limit=100';
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!response.ok) {
                    throw new Error('Erro na requisição: ' + response.statusText);
                }
                const data = await response.json();
                setMedicamentos(data);
            } catch (error) {
                console.error('Erro ao buscar medicamentos:', error);
            }
        }
        buscarMedicamentos();
    }, []);

    return (
        <ScrollView style={styles.container}>
            <Text style={styles.title}>Buscar Medicamento</Text>
            <TouchableOpacity onPress={() => navigation.navigate('Remedios', { focusInput: true, usuario_id })}>
                <View style={styles.searchContainer}>
                    <Ionicons name="search" size={24} color="#808080" style={styles.searchIcon} />
                    <TextInput
                        style={styles.searchInput}
                        placeholder="Buscar medicamento"
                        placeholderTextColor="#a9a9a9"
                        autoCorrect={false}
                        autoCapitalize="none"
                        underlineColorAndroid="transparent"
                        editable={false} // Faz o input ser apenas decorativo aqui
                    />
                </View>
            </TouchableOpacity>
            <Text style={styles.sectionTitle}>Medicamentos</Text>
            <FlatList
                data={medicamentos}
                keyExtractor={(item) => item.id.toString()}
                renderItem={({ item }) => (
                    <TouchableOpacity
                        onPress={() => navigation.navigate('RemedioDetalhes', { usuario_id, id: item.id })}
                    >
                        <View style={styles.favItem}>
                            {/* <Image source={{ uri: item.capa || 'https://juca.eu.org/img/doseexata/default.png' }} style={styles.favImage} /> */}
                            <Image source={{ uri: 'https://juca.eu.org/img/doseexata/default.png' }} style={styles.favImage} />
                            <View style={styles.favDetails}>
                                <Text style={styles.favName}>{item.nome}</Text>
                                <Text style={styles.favDate}>{item.tipo}</Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                )}
            />

        </ScrollView>
    );
};

const styles = StyleSheet.create({


    // buscar 

    searchInput: {
        flex: 1,
        fontSize: 16,
        color: '#333',
        paddingVertical: 0,
        paddingHorizontal: 10,
        borderWidth: 0, // Remove qualquer borda extra
        outlineStyle: 'none', // Remove o estilo padrão da Web
        backgroundColor: 'transparent', // Fundo transparente
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#F5F5F5',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#d3d3d3',
        height: 50,
        paddingHorizontal: 15,
        marginBottom: 20,
        marginHorizontal: 10,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 2,
        width: '100%',
        alignSelf: 'center',
    },
    searchContainerFocused: {
        borderColor: '#004aad', // Destaque no foco
        shadowOpacity: 0.2,
    },
    searchIcon: {
        marginRight: 10,
    },

    // buscar end 
    container: {
        padding: 16,
        backgroundColor: '#F5F5F5',
        flex: 1,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 16,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 16,
        marginBottom: 8,
    },
    favoritesGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start', // Alinha itens da esquerda para a direita
    },
    favoriteItem: {
        alignItems: 'center',
        marginBottom: 16,
        width: Dimensions.get('window').width / 4 - 16, // Divide a largura da tela em 4 colunas
    },
    favoriteImage: {
        width: 60,
        height: 60,
        borderRadius: 8,
    },
    favoriteName: {
        marginTop: 4,
        fontSize: 12,
        textAlign: 'center',
    },
    favItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
        borderWidth: 1,
        borderColor: '#d3d3d3',
        borderRadius: 8,
        padding: 8,
    },
    favImage: {
        width: 50,
        height: 50,
        borderRadius: 8,
        marginRight: 16,
    },
    favDetails: {
        flex: 1,
    },
    favName: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    favDate: {
        fontSize: 14,
        color: '#808080',
        marginTop: 4,
    },
});

export default SearchBar;
